import { Translation } from 'primeng/api';

export const PRIMENG_ES_TRANSLATION: Translation = {
  accept: 'Aceptar',
  reject: 'Cancelar',
  startsWith: 'Empieza con',
  contains: 'Contiene',
  notContains: 'No contiene',
  endsWith: 'Termina con',
  equals: 'Igual a',
  notEquals: 'Distinto de',
  noFilter: 'Sin filtro',
  lt: 'Menor que',
  lte: 'Menor o igual que',
  gt: 'Mayor que',
  gte: 'Mayor o igual que',
  is: 'Es',
  isNot: 'No es',
  before: 'Antes',
  after: 'Después',
  dateIs: 'Fecha es',
  dateIsNot: 'Fecha no es',
  dateBefore: 'Fecha antes de',
  dateAfter: 'Fecha después de',
  clear: 'Limpiar',
  apply: 'Aplicar',
  matchAll: 'Coincidir todo',
  matchAny: 'Coincidir cualquiera',
  addRule: 'Agregar regla',
  removeRule: 'Eliminar regla',
  choose: 'Elegir',
  upload: 'Subir',
  cancel: 'Cancelar',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB'],
  dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
  dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
  monthNames: [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ],
  monthNamesShort: [
    'ene', 'feb', 'mar', 'abr', 'may', 'jun',
    'jul', 'ago', 'sep', 'oct', 'nov', 'dic'
  ],
  dateFormat: 'dd/mm/yy',
  firstDayOfWeek: 1,
  today: 'Hoy',
  weekHeader: 'Sm',
  weak: 'Débil',
  medium: 'Medio',
  strong: 'Fuerte',
  passwordPrompt: 'Introduce una contraseña',
  emptyMessage: 'No hay datos disponibles',
  emptyFilterMessage: 'No se encontraron resultados',
  pending: 'Pendiente',
  chooseYear: 'Elegir año',
  chooseMonth: 'Elegir mes',
  chooseDate: 'Elegir fecha',
  prevDecade: 'Década anterior',
  nextDecade: 'Década siguiente',
  prevYear: 'Año anterior',
  nextYear: 'Año siguiente',
  prevMonth: 'Mes anterior',
  nextMonth: 'Mes siguiente',
  prevHour: 'Hora anterior',
  nextHour: 'Hora siguiente',
  prevMinute: 'Minuto anterior',
  nextMinute: 'Minuto siguiente',
  prevSecond: 'Segundo anterior',
  nextSecond: 'Segundo siguiente',
  am: 'am',
  pm: 'pm',
  searchMessage: '{0} resultados disponibles',
  selectionMessage: '{0} elementos seleccionados',
  emptySelectionMessage: 'Ningún elemento seleccionado',
  emptySearchMessage: 'No se encontraron resultados',
  aria: {
    trueLabel: 'Verdadero',
    falseLabel: 'Falso',
    nullLabel: 'No seleccionado',
    star: '1 estrella',
    stars: '{star} estrellas',
    selectAll: 'Seleccionar todo',
    unselectAll: 'Deseleccionar todo',
    close: 'Cerrar',
    previous: 'Anterior',
    next: 'Siguiente',
    navigation: 'Navegación',
    scrollTop: 'Ir arriba',
    moveTop: 'Mover arriba',
    moveUp: 'Subir',
    moveDown: 'Bajar',
    moveBottom: 'Mover abajo',
    moveToTarget: 'Mover al objetivo',
    moveToSource: 'Mover al origen',
    moveAllToTarget: 'Mover todo al objetivo',
    moveAllToSource: 'Mover todo al origen',
    pageLabel: '{page}',
    firstPageLabel: 'Primera página',
    lastPageLabel: 'Última página',
    nextPageLabel: 'Página siguiente',
    prevPageLabel: 'Página anterior',
    rowsPerPageLabel: 'Filas por página',
    previousPageLabel: 'Página anterior',
    jumpToPageDropdownLabel: 'Saltar a página (selección)',
    jumpToPageInputLabel: 'Saltar a página (entrada)',
    selectRow: 'Fila seleccionada',
    unselectRow: 'Fila deseleccionada',
    expandRow: 'Expandir fila',
    collapseRow: 'Colapsar fila',
    showFilterMenu: 'Mostrar menú de filtros',
    hideFilterMenu: 'Ocultar menú de filtros',
    filterOperator: 'Operador de filtro',
    filterConstraint: 'Condición de filtro',
    editRow: 'Editar fila',
    saveEdit: 'Guardar cambios',
    cancelEdit: 'Cancelar edición',
    listView: 'Vista de lista',
    gridView: 'Vista de cuadrícula',
    slide: 'Diapositiva',
    slideNumber: 'Diapositiva {slideNumber}',
    zoomImage: 'Ampliar imagen',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    rotateRight: 'Rotar a la derecha',
    rotateLeft: 'Rotar a la izquierda',
    listLabel: 'Lista',
    selectColor: 'Seleccionar color',
    removeLabel: 'Eliminar',
    browseFiles: 'Buscar archivos',
    maximizeLabel: 'Maximizar'
  }
};
